import {
  mdiClose,
  mdiRelationOneToOne,
  mdiListBoxOutline,
  mdiPencil,
  mdiStorageTank,
  mdiCheck,
  mdiAlertCircle,
  mdiAlphaXCircleOutline,
  mdiFolder,
  mdiHome,
  mdiLock,
  mdiAlert,
  mdiDownloadCircleOutline,
  mdiMagnify,
  mdiPencilOutline,
} from "@mdi/js";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from "vuetify/iconsets/mdi-svg";
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import * as labs from "vuetify/labs/components";

import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n";
import { createI18n, useI18n } from "vue-i18n";

const messages = {
  en: {
    $vuetify: {
      dataFooter: {
        itemsPerPageText: "Items per page:",
        pageText: "{0}-{1} of {2}",
        itemsPerPageAll: "All",
      },
      noDataText: "No data",
    },
  },
  ru: {
    $vuetify: {
      dataFooter: {
        itemsPerPageText: "Строк на странице:",
        pageText: "{0}-{1} из {2}",
        itemsPerPageAll: "Все",
      },
      noDataText: "Нет данных",
    },
  },
};

const i18n = new createI18n({
  legacy: false, // Vuetify does not support the legacy mode of vue-i18n
  locale: "ru",
  fallbackLocale: "en",
  messages,
});
const vuetify = createVuetify({
  components: {
    ...components,
    ...labs,
  },
  directives,
  icons: {
    defaultSet: "mdi",
    aliases: {
      ...aliases,
      close: mdiClose,
      mdiRelationOneToOne: mdiRelationOneToOne,
      mdiListBoxOutline: mdiListBoxOutline,
      mdiPencil: mdiPencil,
      mdiStorageTank: mdiStorageTank,
      mdiCheck: mdiCheck,
      mdiAlertCircle: mdiAlertCircle,
      mdiAlphaXCircleOutline: mdiAlphaXCircleOutline,
      mdiFolder,
      mdiHome,
      mdiLock,
      mdiAlert,
      mdiDownloadCircleOutline,
      mdiMagnify,
      mdiPencilOutline
    },
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: "myCustomTheme",
    themes: {
      myCustomTheme: {
        dark: false,
        colors: {
          primary: "#202020",
          "primary-darken-1": "#3700B3",
          secondary: "#03DAC5",
          "secondary-darken-1": "#03DAC5",
          error: "#CF6679",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FB8C00",
        },
      },
    },
  },
  locale: {
    adapter: createVueI18nAdapter({ i18n, useI18n }),
  },
});
export { vuetify, i18n };
